import { render, staticRenderFns } from "./providersServices.vue?vue&type=template&id=082befaf&scoped=true&"
import script from "./providersServices.vue?vue&type=script&lang=js&"
export * from "./providersServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082befaf",
  null
  
)

export default component.exports